import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { dateToTimestamp, timestampToDateString } from '../../firebase';
import moment from 'moment';

const DatePicker = ({id, disabled, error, label, onChange, value}) => {

	const getWrapClassName = () => {
		let appendVal = '';
		if (disabled) {
			appendVal = ' disabled';
		} else if (error) {
			appendVal = ' error'
		}
		return `form-element ${appendVal}`
	}

	const handleValueChange = (date) => {
		const value = date.formattedValue;
		if (onChange) {
			if (moment(value, 'MM/DD/YYYY',true).isValid()) {
				onChange(dateToTimestamp(value));
			} else {
				onChange(null);
			}
		}

	}

	function getFormattedValue () {
		if (typeof value === 'object' && value !== null) {
			return timestampToDateString(value);
		}
		return '';
	}
  return (
		<div className={getWrapClassName()}>
			{ label && <h2><label htmlFor={id}>{label}:</label></h2> }
			<div className="input-wrap">
				<NumberFormat
					id={id}
					format="##/##/####"
					placeholder="MM/DD/YYYY"
					onValueChange={handleValueChange}
					value={ getFormattedValue() }
					disabled={disabled}
				/>
			</div>
		</div>
  );
}

DatePicker.propTypes = {
	disabled: PropTypes.bool,
	error: PropTypes.string,
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func,
	value: PropTypes.object
};

export default DatePicker;
